<template>
  <div id="app">
     <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
html,body{
  width: 100%;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* min-width: 1200px; */
  color: #2c3e50;
  position: relative;
  width: 100%;
  height: 100%;
}

.flexColumn{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.flexRow{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.flexRowBetween{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.borderBtm{
  border-bottom:.1px solid #efefef;
}

.privacyTime{
        color: #fff;
    line-height: 21px;
    font-size: 15px;
    font-weight: 500;
    word-break: break-all;
}

.privacyTitle{
    color: #fff;
    line-height: 21px;
    font-size: 15px;
    font-weight: 500;
    word-break: break-all;
}
</style>
